<div class="Maintenance">
  <img src="/assets/images/university.png" class="Maintenance-logo" alt="Decathlon University">
  <img src="/assets/images/maintenance.svg" class="Maintenance-image" alt="Decathlon University">
  <h3 class="Maintenance-title">{{'MAINTENANCE.TITLE' | translate}}</h3>
  <p class="Maintenance-text">{{'MAINTENANCE.INFO' | translate}}</p>

  <div class="Maintenance-actions">
    <button class="Maintenance-button" (click)="buttonAction()">
      {{'MAINTENANCE.BUTTON_LABEL' | translate}}
    </button>
  </div>
</div>